import {HttpErrorResponse} from '@angular/common/http';

export function isExceededLicenseError(error: HttpErrorResponse): boolean {
  return error.error?.code === 40202 && error.error.properties?.EXCEEDED_LICENSE_INFO;
}
